import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally { setLoading(false); }
  };

  const field = "w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white placeholder:text-white/40 outline-none focus:border-[#ff5147] transition";

  return (
    <div className="min-h-screen grid place-items-center px-6 section-dark">
      <Seo title="Admin Login | Keys Event Center" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-dark rounded-3xl p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/brand/logo-badge.png" alt="Keys Event Center" className="h-36 mx-auto mb-4 object-contain" />
          <h1 className="font-display text-2xl font-bold text-white flex items-center justify-center gap-2"><Lock size={20} className="text-[#f6b64a]" /> Admin Portal</h1>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input type="text" aria-label="Username" autoComplete="username" placeholder="Username" className={field} value={username} onChange={(e) => setUsername(e.target.value)} data-testid="admin-username" />
          <input type="password" aria-label="Password" autoComplete="current-password" placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          {error && <p className="text-[#ff7a7a] text-sm" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-btn">
            {loading ? "Signing in…" : <><LogIn size={18} /> Sign In</>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
